export default "__VITE_ASSET__CSQv7jN2__"